<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Scope Definition
      <div slot="right">
        <b-button type="is-normal import-button" @click="redirectToScopes"
          >Cancel</b-button
        >
        <b-button
          type="is-primary import-button"
          @click="activateWorkflowDialog"
          v-if="!isViewOnly"
          >Save</b-button
        >
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <b-collapse class="validation-panel" animation="slide">
        <div class="card validation-card">
          <div class="card-content">
            <div class="columns">
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="calendar-start"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">
                    Valid From
                  </div>
                  <div class="columns">
                    <a
                      ref="#"
                      @click.prevent="setDate('Valid From', 'valid_from')"
                    >
                      <p
                        class="no-padding validation-import-comments"
                        v-if="formData && formData.valid_from"
                      >
                        {{ newDateFormatter(formData.valid_from) }}
                      </p>
                      <p class="no-padding validation-import-comments" v-else>
                        Set Start
                      </p></a
                    >
                  </div>
                </div>
              </div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="calendar-end"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">
                    Valid To
                  </div>
                  <div class="columns">
                    <a ref="#" @click.prevent="setDate('Valid To', 'valid_to')"
                      ><p
                        class="no-padding validation-import-comments"
                        v-if="formData && formData.valid_to"
                      >
                        {{ newDateFormatter(formData.valid_to) }}
                      </p>
                      <p class="no-padding validation-import-comments" v-else>
                        Set Finish
                      </p></a
                    >
                  </div>
                </div>
              </div>
              <div class="column columns no-margin" v-if="formData">
                <div class="column" v-if="!isAdd">
                  <b-icon icon="calendar-clock"></b-icon>
                </div>
                <div class="column is-three-quarters" v-if="!isAdd">
                  <div class="columns validation-text-header">
                    Last Updated
                  </div>
                  <div class="columns">
                    <p class="no-padding" v-if="formData">
                      {{ formData.updated_at }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin" v-if="formData">
                <div class="column" v-if="!isAdd">
                  <b-icon icon="account-edit"></b-icon>
                </div>
                <div class="column is-three-quarters" v-if="!isAdd">
                  <div class="columns no-padding validation-text-header">
                    Last Updated by
                  </div>
                  <div class="columns">
                    <p class="no-padding">{{ formData.updated_by_name }}</p>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin"></div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="content-save"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns no-padding validation-text-header">
                    Current Status
                  </div>
                  <div class="columns">
                    <p v-if="isAdd" class="no-padding validation-import-status">
                      Unsaved
                    </p>
                    <p
                      v-if="formData && !isAdd"
                      class="no-padding validation-import-status"
                    >
                      {{ formData.status }}
                    </p>
                    &nbsp;
                    <span
                      v-if="formData && !isAdd && formData.status == 'Rejected'"
                      class="additional-info"
                    >
                      <b-tooltip
                        type="is-primary"
                        :label="formData.comment_for_rejection"
                        multilined
                      >
                        <i class="mdi mdi-information"></i>
                      </b-tooltip>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </section>
    <section class="section is-main-section scope-main-section" v-if="formData">
      <div class="scope-bundle">
        <div class="scope">
          <span></span>
          <span>
            <span v-on:click="addRuletoScope"
              ><a href="#"><b-icon icon="plus"/></a
            ></span>
          </span>
        </div>
        <div class="scope" v-if="formData.country_name">
          <div class="country-with-flag">
            <country-flag
              :country="formData.country_code"
              size="small"
              v-if="formData.country_code"
            />
            <span class="scope-text">{{ formData.country_name }}</span>
          </div>
        </div>
        <hr class="scope-hr" />
      </div>
      <div class="scope-bundle" v-if="formData.scheme_name">
        <div class="scope">
          <span class="scope-text">{{ formData.scheme_name }}</span>
        </div>
        <hr class="scope-hr" />
      </div>
      <div class="scope-bundle" v-if="formData.stream_name">
        <div class="scope">
          <span class="scope-text">{{ formData.stream_name }}</span>
        </div>
        <hr class="scope-hr" />
      </div>
      <ul class="scope-rule-list">
        <li v-for="(value, index) in selectedRules" :key="index" class="scope">
          <span v-on:click="showRule(value)"
            ><a href="#">{{ value.name }}</a></span
          >
          <span v-on:click="deselectRule(value)"
            ><a href="#"><b-icon icon="minus"/></a
          ></span>
        </li>
      </ul>
      <br /><br />
      <div
        class="columns"
        v-if="formData && formData.status == 'Sent for Approval'"
      >
        <div class="column">
          <ul class="context-options-left">
            <li>
              <b-button
                slot="right"
                native-type="submit"
                type="is-success"
                @click="addOrEditScope('confirm')"
              >
                Approve
              </b-button>
            </li>
            <li>
              <b-button
                slot="right"
                @click="rejectBtnAction"
                type="is-danger"
                class="deactivateBtn"
              >
                Reject
              </b-button>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <SetTimeModal
      :is-active="isModalActive"
      :modalHeader="setModalHeader"
      :formData="formDataDate"
      @confirm="setConfirmTime"
      @cancel="exitModal"
    />
    <select-rule
      :is-active="isSelectRuleModalActive"
      @confirm="addSelecedRule"
      @cancel="closeSelectRuleModal"
    />
    <view-rules
      :is-active="isViewModalActive"
      :formData="viewRule"
      @cancel="cancelViewRule"
      :show-edit-button="false"
      :rule-tags="ruleTags"
    />
    <workflow-dialog
      :is-active="isWorkflowDialogActive"
      @submit="addOrEditScope"
      @cancel="closeWorkflowDialog"
    />

    <b-modal v-model="isRejectModalActive" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title title-reject">
            You are rejecting the changes
          </p>
        </header>
        <section class="modal-card-body">
          <b-field label="Please describe the reasons">
            <b-input
              maxlength="500"
              type="textarea"
              v-model="comment"
            ></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button
            label="Close"
            class="reject-modal-close-button"
            @click="isRejectModalActive = false"
          />
          <b-button label="Reject" type="is-danger" @click="rejectScope" />
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import RulesManagerService from "../../services/RulesManagerService";
import { mapGetters } from "vuex";
import SetTimeModal from "@/components/RulesManager/SetTimeModal.vue";
import UtilityMixin from "@/mixins/UtilityMixin";
import SelectRule from "@/components/RulesManager/SelectRule.vue";
import ViewRules from "@/components/RulesManager/ViewRules.vue";
import WorkflowDialog from "@/components/RulesManager/WorkflowDialog.vue";
export default {
  name: "ScopeDefinition",
  components: {
    HeroBar,
    TitleBar,
    SetTimeModal,
    SelectRule,
    ViewRules,
    WorkflowDialog
  },
  mixins: [UtilityMixin],
  props: {
    isViewOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      viewRule: {},
      data: null,
      comment: null,
      formData: [],
      isDataLoading: false,
      isModalActive: false,
      isWorkflowDialogActive: false,
      isRejectModalActive: false,
      isViewModalActive: false,
      isSelectRuleModalActive: false,
      selectedRules: [],
      action: null,
      isAdd: this.$route.params.isAdd,
      //isViewOnly: this.$route.params.isViewOnly,
      editObject: this.getClearFormObject(),
      viewOnly: false,
      RulesManagerService: new RulesManagerService(),
      valid_to: null,
      valid_from: null,
      setModalKey: null,
      setModalHeader: null,
      formDataDate: null,
      ruleTags: []
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission"]),
    editObjectName() {
      return this.editObject || this.getClearFormObject();
    },
    titleStack() {
      return [
        { url: "#", name: "Rules Manager" },
        { url: "/rulesManager/scopes", name: "Scopes" },
        { url: "#", name: "Scope Definition" }
      ];
    }
  },
  mounted() {
    this.checkExternalPermission();
    this.getScopeById();
    this.fetchRuleTags();
  },
  methods: {
    newDateFormatter(value) {
      return new Date(value).toLocaleDateString("fr-CA");
    },

    fetchRuleTags() {
      this.RulesManagerService.getRulesTags().subscribe(response => {
        this.ruleTags = response;
      });
    },
    rejectBtnAction() {
      this.isRejectModalActive = true;
    },
    rejectScope() {
      this.formData[`comment`] = this.comment;
      this.isRejectModalActive = false;
      this.addOrEditScope("reject");
    },
    activateWorkflowDialog() {
      this.isWorkflowDialogActive = true;
    },
    closeWorkflowDialog() {
      this.isWorkflowDialogActive = false;
    },
    deselectRule(rule) {
      const index = this.selectedRules.indexOf(rule);
      if (index > -1) {
        this.selectedRules.splice(index, 1);
      }
    },
    showRule(value) {
      const tagSelected = this.ruleTags
        .filter(item => (value["tags"] ? value["tags"].includes(item.id) : ""))
        .map(a => a.name)
        .toString();

      value["tags"] = tagSelected == "" ? "NA" : tagSelected;
      this.isViewModalActive = true;
      this.viewRule = value;
    },
    cancelViewRule() {
      this.isViewModalActive = false;
    },
    addSelecedRule(rule) {
      this.selectedRules.push(rule);
      this.isAdd ? this.formData.rule.push(rule.id) : "";
      this.isSelectRuleModalActive = false;
    },

    addRuletoScope() {
      this.isSelectRuleModalActive = true;
    },
    closeSelectRuleModal() {
      this.isSelectRuleModalActive = false;
    },
    setConfirmTime(value) {
      this.formData[`${this.setModalKey}`] = new Date(value).toLocaleDateString(
        "fr-CA"
      );
      this.isModalActive = false;
    },
    convertToDate(dt) {
      let newDate = null;
      if (dt == " - ") {
        return newDate;
      }
      if (dt != null) {
        newDate = new Date(dt);
      }
      return newDate;
    },
    getScopeById() {
      if (!this.isAdd) {
        this.RulesManagerService.getScopeById(this.$route.params.id).subscribe(
          response => {
            this.formData = response;
            // this.selectedRules = this.formData.rule.filter(rule => rule.active);

            if (this.formData.status != "Approved") {
              this.selectedRules = this.formData.rule.filter(
                rule => rule.active
              );
            } else {
              this.selectedRules = this.formData.rule;
            }
            this.formData.updated_at
              ? (this.formData.updated_at = this.dateToLocalDate(
                  this.formData.updated_at
                ))
              : null;
          },
          this.handleApiError
        );
      } else {
        this.formData = this.$route.params.formData;
        this.formData.rule = [];
      }
    },
    getClearFormObject() {
      this.formData = [];
    },
    redirectToScopes() {
      this.formData = [];
      this.$router.push({
        name: "rulesManager.scopes"
      });
    },
    addOrEditScope(workflow = "") {
      this.closeWorkflowDialog();
      if (this.isAdd) {
        this.addScope(workflow);
      } else {
        this.editScope(workflow);
      }
    },
    addScope(workflow) {
      this.RulesManagerService.addScopeData(this.formData, workflow).subscribe(
        () => {
          this.$buefy.toast.open({
            message: "Data is added successfully!",
            type: "is-success"
          });
          this.redirectToScopes();
        },
        this.handleApiError
      );
    },
    editScope(workflow) {
      this.formData.rule = this.selectedRules;
      this.RulesManagerService.editScopeData(this.formData, workflow).subscribe(
        () => {
          this.$buefy.toast.open({
            message: "Data is updated successfully!",
            type: "is-success"
          });
          this.redirectToScopes();
        },
        this.handleApiError
      );
    },
    exitModal() {
      this.setModalHeader = null;
      this.setModalKey = null;
      this.isModalActive = false;
    },

    setDate(value, key) {
      if (!this.isViewOnly) {
        this.setModalHeader = value;
        this.setModalKey = key;
        this.isModalActive = true;
        this.formDataDate = this.convertToDate(
          this.formData[`${this.setModalKey}`]
        );
      }
    },
    handleApiError(reason) {
      let errorMessage = null;
      if (reason?.response?.data) {
        if (reason.response.data["detail"]) {
          errorMessage = reason.response.data["detail"];
        } else if (reason.response.data["error"]) {
          errorMessage = reason.response.data["error"];
        } else if (reason.response.data["name"]) {
          errorMessage = reason.response.data["name"];
        } else {
          errorMessage = "An error occurred";
        }
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
        //onConfirm:() => this.redirectToScopes()
      });
      this.isDataLoading = false;
    }
  }
};
</script>
